export default [
  [1, 1, 0.95, 0.9, 0.8, 0.65, 0.5, 0.4, 0.35],
  [2, 5, 1, 0.95, 0.9, 0.8, 0.65, 0.5, 0.4],
  [3, 5, 5, 1, 0.95, 0.9, 0.8, 0.65, 0.5],
  [4, 5, 5, 1, 0.95, 0.9, 0.8, 0.65, 0.5],
  [5, 5, 1, 0.95, 0.9, 0.8, 0.65, 0.5, 0.4],
  [1234, 5, 1, 0.95, 0.9, 0.8, 0.65, 0.5, 0.4],
  [7, 5, 1, 0.95, 0.9, 0.8, 0.65, 0.5, 0.4],
] as const;
